
$('.sf-nav .sf__menu-item-level1 > a').each(function () {
    $(this).attr({
        'role': 'button',
        'aria-expanded': 'false',
        'tabindex': 0
    });
});
$('.opener_coner_aria a').removeAttr('aria-label');
$('.slider_silicone_kitchecn .pf-slide').removeAttr('tabindex');
$('.kitchen_foot_mama a').attr('aria-label', '#Kitchenmama : opens in a new tab');
$('.sf-nav .sf__menu-item-level1 > a').removeAttr('href');
$('br').attr('aria-hidden','true');
$('div[data-pf-type="ProductMedia"] .splide__slide').attr('aria-hidden','true');
$('div[data-product-type="price"]').prepend('<span class="sr-only">sale price</span>');
$('div[data-product-type="compare_at_price"]').prepend('<span class="sr-only">regular price</span>');
$('#compact-5965762c-1f3a-4752-80cb-c19b7f3f1383').remove();
$('#compact-a72ad714-3094-4db2-940e-4dee373d2da1').remove();
$('#compact-fd978e15-6ad9-486b-ae36-42d526b9dacf').remove();
$('#mobile-menu ul li ul li:nth-child(4) > span').attr('aria-hidden','true');

// if (typeof jQuery !== 'undefined') {
//     $('div[data-product-type="price"]').prepend('<span class="sr-only">sale price</span>');
//     $('div[data-product-type="compare_at_price"]').prepend('<span class="sr-only">regular price</span>');
    
//   } else {
//     console.warn("jQuery not loaded");
//   }

// if (typeof jQuery !== 'undefined') {
//     // Check if the "sale price" span exists, and add only if it's not there
//     if ($('div[data-product-type="price"] .sr-only').text() !== 'sale price') {
//         $('div[data-product-type="price"]').prepend('<span class="sr-only">sale price</span>');
//     }

//     // Check if the "regular price" span exists, and add only if it's not there
//     if ($('div[data-product-type="compare_at_price"] .sr-only').text() !== 'regular price') {
//         $('div[data-product-type="compare_at_price"]').prepend('<span class="sr-only">regular price</span>');
//     }
// } else {
//     console.warn("jQuery not loaded");
// }

$("li.sf__menu-item-level1").on("click keypress", function(e) {
    e.stopPropagation();
    
     if (e.type === 'keypress' && e.which !== 13) {
        return;
    }

    const dropdown = $(this).find("a").first();

    if (dropdown.attr("aria-expanded") === "false") {

        jQuery("li.sf__menu-item-level1 > a").attr("aria-expanded", "false");
        jQuery("li.sf__menu-item-level1").removeClass("sf-menu-item--active");

        dropdown.attr("aria-expanded", "true");
        $(this).addClass("sf-menu-item--active");

    } else {
        
        dropdown.attr("aria-expanded", "false");
        $(this).removeClass("sf-menu-item--active");

    }
});

// Drop Down Menu  Auto close

// $(document).on('focusin', function(event) {
//   if ($(event.target).closest(".sf__menu-item-level1").length === 0) {
//     $("li.sf__menu-item-level1 > a").attr("aria-expanded", "false");
//     $("li.sf__menu-item-level1").removeClass("sf-menu-item--active");
    
//   }
// });

$(document).keydown(function(e) {
    if (e.key === "Escape") {
        $("li.sf__menu-item-level1 > a").attr("aria-expanded", "false");
        $("li.sf__menu-item-level1").removeClass("sf-menu-item--active");
    }
});

document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href')?.trim();
    // Skip if no href
    if (!href) return;
    // Skip mailto: and tel:
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return;
    try {
      // Create absolute URL based on current site
      const linkUrl = new URL(href, window.location.origin);
      const isExternal = linkUrl.origin !== window.location.origin;
      if (isExternal) {
        const label = link.getAttribute('title')?.trim() || link.textContent.trim();
        if (label && !link.hasAttribute('aria-label')) {
          link.setAttribute('aria-label', `${label} (opens in a new window)`);
        }
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (error) {
      return;
    }
  });



  $(document).ready(function () {
    function updateAriaHidden() {
        //  $('.home-banner__slideshow .sf__slide--text-white').attr('aria-hidden', 'true');
        // $('.home-banner__slideshow .swiper-slide.swiper-slide-active').attr('aria-hidden', 'false');
    }

    function addAccessibilityToNavButtons() {
        $('.home-banner__slideshow .sf-slider__controls').on('click', function () {
            setTimeout(updateAriaHidden, 100);
        });
    }

    updateAriaHidden();

    // Corrected Swiper event listener
    $('.home-banner__slideshow .swiper-container').on('slideChange', function () {
        updateAriaHidden();
    });

    addAccessibilityToNavButtons();
});

document.querySelectorAll('[role="radio"]').forEach(radio => {
    radio.addEventListener('click', () => {
      // Sabhi radio buttons ka aria-checked false set karein
      document.querySelectorAll('[role="radio"]').forEach(r => r.setAttribute('aria-checked', 'false'));
      // Clicked radio button ka aria-checked true set karein
      radio.setAttribute('aria-checked', 'true');
    });
  });
  

  $("#CollectionProductGrid .f-product-form").on("click", function () { 
     setTimeout(function () { 
            $(".sf-modal__close").attr("tabindex", 0).focus();  
      }, 1000);
    });
      $(".sf-modal__close").on("click", function () { 
        setTimeout(function () { 
               $("#CollectionProductGrid .f-product-form").attr("tabindex", 0).focus();  
         }, 1000);
        });
      
// $('.pf-anchor').attr('aria-expanded', 'false');
// $('.pf-anchor').click(function (e) {
//   e.preventDefault();
//   $(this).attr('aria-expanded', function (i, attr) {
//     return attr == 'true' ? 'false' : 'true'
//   });
// });
$('.Accor_transcript_button summary').attr('role', 'button');
$('.Accor_transcript_button summary').attr('aria-label', 'View Video Transcript');
$('.Accor_transcript_button summary').attr('aria-expanded', 'false');
$('.Accor_transcript_button summary').click(function (e) {
  e.preventDefault();
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });
});

const toggleBtn = document.getElementById('transcriptToggle');
const content = document.getElementById('transcript');

toggleBtn.addEventListener('click', () => {
  const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
  toggleBtn.setAttribute('aria-expanded', String(!expanded));
  content.hidden = expanded;
});

// $(document).ready(function () {
//     function updateTestiAriaHiddens() {
//         $('.testimonials_banner_slider .swiper-slide').attr('aria-hidden', 'true');
//         $('.testimonials_banner_slider .swiper-slide.swiper-slide-active').attr('aria-hidden', 'false');
//     }

//     function AccessibilityToNavButton() {
//         $('.testimonials_banner_slider .sf-slider__controls').on('click', function () {
//             setTimeout(updateTestiAriaHiddens, 100);
//         });
//     }

//     updateTestiAriaHiddens();

//     // Corrected Swiper event listener
//     $('.testimonials_banner_slider .swiper-container').on('slideChange', function () {
//         updateTestiAriaHiddens();
//     });

//     AccessibilityToNavButton();
// });


// $(document).ready(function () {
//   function updateAriaHidden() {
//       $('.testimonials_banner_slider .swiper-slide').attr('aria-hidden', 'true');

//       var $active = $('.testimonials_banner_slider .swiper-slide-active');
//       $active.attr('aria-hidden', 'false');
//       $active.next().attr('aria-hidden', 'false');
//       $active.next().next().attr('aria-hidden', 'false');
//   }

//   function addAccessibilityToNavButtons() {
//       $('.testimonials_banner_slider .sf-slider__controls').on('click', function () {
//           setTimeout(updateAriaHidden, 100);
//       });
//   }

//   updateAriaHidden();

//   const swiperEl = document.querySelector('.testimonials_banner_slider .swiper-container');
//   if (swiperEl && swiperEl.swiper) {
//       swiperEl.swiper.on('slideChange', updateAriaHidden);
//   }

//   addAccessibilityToNavButtons();
// });
// $("#cartonheader").on("click", function () { 
//   setTimeout(function () { 
//          $(".scd__close").attr("tabindex", 0).focus();  
//    }, 1000);});

// $(document).ready(function () {
//   $('div[data-product-type="price"]').prepend('<span class="sr-only">sale price</span>');
//   $('div[data-product-type="compare_at_price"]').prepend('<span class="sr-only">regular price</span>');
// });

$(document).ready(function () {
  $('div[data-product-type="price"]').each(function() {
    // Check if compare price exists for this product
    var comparePrice = $(this).siblings('div[data-product-type="compare_at_price"]');
    
    if (comparePrice.length && comparePrice.text().trim() !== '') {
      // If compare price exists and isn't empty, this is a sale price
      $(this).prepend('<span class="sr-only">sale price</span>');
      comparePrice.prepend('<span class="sr-only">regular price</span>');
    } else {
      // If no compare price, this is just the regular price
      $(this).prepend('<span class="sr-only">regular price</span>');
    }
  });
});

$(".search_pop-up").on("click", function () { 
  setTimeout(function () { 
         $(".sf-search-form button").attr("tabindex", 0).focus();  
}, 1000);});



// var existCondition = setInterval(function() {
//     if ($('.sf-modal__close').length) { 
//      clearInterval(existCondition);
//      runMyFunction07();
//     }
//    }, 200);

//    function runMyFunction07(){
//    //     console.log("price range");
//    $('.sf-modal__close').attr('aria-label', 'Close dialog');
//    }


